<template>
  <div class="main-body">
    <div class="header">NB报警器</div>
    <div class="out">
      <div class="search2">

        <el-button size="mini" type="primary" plain @click.native="toggleModalAdd">绑定设备</el-button>
        <div style="float:right">

          <el-input v-model="userName" placeholder="选择老人" disabled style="width: 250px;margin-right: 10px">
            <el-button slot="append" icon="el-icon-search" @click="getElderly"></el-button>
            <el-button slot="prepend" icon="el-icon-close" @click="clearElderly"></el-button>
          </el-input>

          <el-input size="mini" placeholder="请输入设备号" v-model="imei" clearable style="margin-right:10px;width:140px"></el-input>

          <el-button size="mini" type="primary" icon="el-icon-search" @click="getList(true)">搜索</el-button>
        </div>

        <div style="clear: both;"></div>
      </div>


      <el-table class="table" size="mini" v-loading="tableLoading"  :data="tableData" :height="th" border style="width: 100%;">

        <el-table-column prop="userName" label="用户名" width="100" fixed></el-table-column>
        <el-table-column prop="phone" label="手机号" width="150"></el-table-column>
        <el-table-column prop="imei" label="设备Imei号" width="150"></el-table-column>
        <el-table-column prop="placeName" label="位置" width="100"></el-table-column>
        <el-table-column label="设备类型" width="150">
          <template slot-scope="scope">
            <span v-if="scope.row.deviceType == 1">报警按钮</span>
            <span v-if="scope.row.deviceType == 2">人体红外探测器</span>
            <span v-if="scope.row.deviceType == 3">门磁探测器</span>
            <span v-if="scope.row.deviceType == 4">水浸探测器</span>
            <span v-if="scope.row.deviceType == 5">可燃气探测器</span>
            <span v-if="scope.row.deviceType == 6">一氧化碳探测器</span>
            <span v-if="scope.row.deviceType == 7">烟温探测器</span>

          </template>
        </el-table-column>
        <el-table-column prop="zoneCodePathName" label="所在区域" width="300" ></el-table-column>

        <el-table-column prop="createTime" label="绑定时间" :formatter="timefilter" min-width="180"></el-table-column>

        <el-table-column fixed="right" label="操作" width="200">
          <template slot-scope="scope">
            <el-button type="success" size="mini"  @click="getData(scope.$index, scope.row)" >数据</el-button>
            <el-button type="danger" size="mini" @click="RemoveBinding(scope.row)">解绑</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="page">
        <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
        <div style="float: left;">
          <el-pagination small
                         background
                         layout="prev, pager, next"
                         :total="totalItems"
                         :page-size="20"
                         :current-page.sync="currentPage"  @current-change="current_change"
          ></el-pagination>
        </div>
        <div style="clear: both;"></div>
      </div>

    </div>

    <Add ref="myAdd" v-show="showModalAdd" v-on:closeAdd="showModalAdd=false"  v-on:getList="getList"></Add>
    <PushData ref="myPushData" v-show="pushDataShow" v-on:closePushData="closePushData"></PushData>

    <Elderly ref="myElderly" v-show="showModalGetElderly" v-on:closeElderly="showModalGetElderly=false" v-on:setElderly="setElderly"></Elderly>

  </div>
</template>

<script>
import { timeStr,timefilters } from "@/common/times";
import { hex_md5 } from "@/common/Base64MD5";
import { getStaffDTO} from "@/utils/auth";

import Add from "./Add"
import Elderly from "@/views/Elderly/Comm/ElderlyInsCheckIn";
import PushData from "../Comm/PushData";

export default {
  name: "Role",
  data() {
    return {
      tableLoading:false,

      showModalAdd:false,

      pushDataShow:false,
      showModalGetElderly:false,

      tableData: [],
      totalItems: 0,
      pageSize: 20,
      currentPage: 1,

      th: 0,

      userCode: "",
      userName:'',
      imei: "",


    };
  },
  components: {Add,Elderly,PushData},
  created() {
    this.getList();
    this.th = this.$store.state.tableHeight;
  },

  watch: {
    //监听全局变量
    "$store.state.tableHeight": function (val) {
      this.th = val;
    },
  },
  methods: {

    toggleModalAdd: function () {
      this.$refs.myAdd.init();
      this.showModalAdd = !this.showModalAdd;
    },


    getElderly(){
      this.showModalGetElderly = !this.showModalGetElderly;
      this.$refs.myElderly.init();
    },
    setElderly(row){
      this.userCode = row.userCode;
      this.userName = row.name;
    },
    clearElderly(){
      this.userCode = '';
      this.userName = '';
    },



    getData(index,row){
      this.$refs.myPushData.init(row.userCode);
      this.pushDataShow =!this.pushDataShow;
    },
    closePushData(){
      this.pushDataShow =!this.pushDataShow;
    },


    current_change: function (currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    getList(isSearch){
      if(isSearch)this.currentPage=1
      var _this=this
      this.tableLoading=true

      this.$axios({
        method: "post",
        url: this.$deviceUrl + "DeviceOWon/PageByInsCode",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          pageIndex: this.currentPage,
          pageSize: this.pageSize,
          imei: this.imei,
          userCode:this.userCode,
          deviceType:-1,
          institutionCode : getStaffDTO().institutionDTO.institutionCode,
        },
      }).then((response) => {
            _this.tableLoading=false
            if (response.data.error == 0) {
              this.tableData = response.data.data.list;
              this.totalItems = response.data.data.total;
            } else if (response.data.error == 1) {
              this.$message.error(response.data.message);
            }
          }).catch(function (error) {
            _this.tableLoading=false
            console.log(error);
          });
    },

    timefilter(row, column, cellValue) {
      return timefilters(cellValue);
    },

    RemoveBinding(row) {
      this.$confirm("您确定要解绑设备吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
            this.$axios({
              method: "post",
              url: this.$deviceUrl + "DeviceOWon/Delete",
              data: {
                timeStr: timeStr,
                sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
                deviceOWonCode: row.deviceOWonCode,
              },
            }).then((response) => {
                  //console.log(response);
                  if (response.data.error == 0) {
                    this.$message({message: "解绑成功", type: "success",});
                    this.getList();

                  } else if (response.data.error == 1) {
                    this.$message.error(response.data.message);
                  }
                }).catch(function (error) {
                  console.log(error);
                });
          }).catch(() => {
            this.$message({type: "info", message: "已取消解绑",});
          });

    },



  },
};
</script>

<style scoped>
</style>
